
import { defineComponent } from "vue";
export default defineComponent({
  name: "Story",
  setup() {
    const goToWizard = () => {
      const wizardElement = document.getElementById("generator-wizard");
      if (wizardElement) {
        wizardElement.scrollIntoView();
      }
    };
    return {
      goToWizard,
    };
  },
});
